/*
 * Whether a /reset-password/ route's query params represent a valid incoming link —
 * either a Descope magic-link token (`t`) or a legacy Member Hub signed link
 * (signature + token + expires + id/uuid). Used by the page-level `validate` route
 * guard on both `reset-password.vue` and `dashboard/reset-password.vue`.
 */
export function isValidResetPasswordLink (query) {
  if (query?.t && !Array.isArray(query.t)) return true
  return !!query?.signature && !!query?.token && !!query?.expires && !!(query?.id || query?.uuid)
}
